import { NewUserData } from "@app/core/user/domain/new-user";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { Observable } from "rxjs";
import { User } from "@app/core/user/domain/user";

/**
 * User profile picture repository.
 */
export abstract class UserProfilePictureRepo {
  /**
   * Select a photo from the device.
   * @returns the photo selected.
   */
  abstract uploadPhoto(): Observable<string>;
  /**
   * Uses the camera to take a photo.
   * @returns the photo taken.
   */
  abstract takePhoto(): Observable<string>;
}
